export function seatingChartEmptyCart() {
  // return addLoadingEffect().then(function() {
  // var $nextURL, $scheduleEid
  // $('#icon-shoppingcart-num').html(0)
  // $scheduleEid = getCookie('scheduleEid')
  // $nextURL = 'event/view/view/schedule/' + $scheduleEid + '/choice/seating-chart'
  return new Promise((resolve, _) => {
    $.ajax({
      url: '/store/shopping-cart/remove-all/ajax/1/',
      type: 'post',
      // data: {},
      success: data => {
        console.debug('seatingChartEmptyCart')
        // removeAllSeats()
        $('#mobile-header-timer-seating-chart')
          .TimeCircles()
          .stop()

        // window.location.reload(true)
        resolve()
        // setTimeout(() => {
        //   window.location.reload(true)
        // }, 1000)
      }
    })
  })
}

export default seatingChartEmptyCart
